import { writable } from "svelte/store";
export const customerStatus = writable(3);
export var ForecastType;
(function (ForecastType) {
    ForecastType[ForecastType["HOURLY"] = 0] = "HOURLY";
    ForecastType[ForecastType["DAILY"] = 1] = "DAILY";
})(ForecastType || (ForecastType = {}));
;
export var cType;
(function (cType) {
    cType[cType["TEMP"] = 0] = "TEMP";
    cType[cType["WBGT"] = 1] = "WBGT";
    cType[cType["WIND"] = 2] = "WIND";
    cType[cType["PRECIP"] = 3] = "PRECIP";
    cType[cType["GUST"] = 4] = "GUST";
    cType[cType["FEEL"] = 5] = "FEEL";
    cType[cType["PM2_5"] = 6] = "PM2_5";
    cType[cType["PM10"] = 7] = "PM10";
    cType[cType["OZONE"] = 8] = "OZONE";
    cType[cType["AQI"] = 9] = "AQI";
    cType[cType["LR1"] = 12] = "LR1";
    cType[cType["LR_C2G"] = 13] = "LR_C2G";
})(cType || (cType = {}));
export var PollutantType;
(function (PollutantType) {
    PollutantType[PollutantType["PM2_5"] = 0] = "PM2_5";
    PollutantType[PollutantType["PM10"] = 1] = "PM10";
    PollutantType[PollutantType["OZONE"] = 2] = "OZONE";
    PollutantType[PollutantType["AQI"] = 3] = "AQI";
})(PollutantType || (PollutantType = {}));
;
export var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["DEF"] = 0] = "DEF";
    WidgetType[WidgetType["IMG"] = 1] = "IMG";
    WidgetType[WidgetType["RADAR"] = 2] = "RADAR";
})(WidgetType || (WidgetType = {}));
;
export var PaletteType;
(function (PaletteType) {
    PaletteType[PaletteType["DARK"] = 0] = "DARK";
    PaletteType[PaletteType["LIGHT"] = 1] = "LIGHT";
})(PaletteType || (PaletteType = {}));
;
export const widgetId = writable("");
export const widgetInfo = writable();
//Add updated field to widgetInfo
export const updated = writable(new Date());
//Policies
export const lightningDelayError = writable(false);
export const lightningDelay = writable(30);
export const allClear = writable(60000 * 0.5);
export const radius1 = writable(8);
//Conditions & location
export const hourlyForecast = writable();
export const dailyForecast = writable();
export const conditions = writable();
export const aqiData = writable();
export const organizationLocation = writable();
//images
export const mapImageBase64String = writable(undefined);
export const radarImageBase64Strings = writable(undefined);
export const lightningImageBase64String = writable(undefined);
